module.exports = __webpack_public_path__ + "static/media/isat.4e49eb58.png";